var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avalanche-avax-logo 1",
    clipPath: "url(#clip0_721_122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.9517 5.48936H8.01953V23.4468H33.9517V5.48936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9857 16C41.9857 24.8249 32.5901 31.9787 20.9997 31.9787C9.40943 31.9787 0.0136719 24.8249 0.0136719 16C0.0136719 7.17519 9.40943 0.0212708 20.9997 0.0212708C32.5901 0.0212708 41.9857 7.17519 41.9857 16ZM15.0529 22.3587H10.9801C10.1242 22.3587 9.7015 22.3587 9.44375 22.2332C9.16534 22.0957 8.99522 21.8681 8.97459 21.6168C8.95911 21.3853 9.17051 21.1026 9.59325 20.5373L19.6495 7.04116C20.0774 6.46806 20.2939 6.1815 20.5672 6.07553C20.861 5.9617 21.2116 5.9617 21.5055 6.07553C21.7787 6.1815 21.9952 6.46806 22.4231 7.04116L24.4905 9.78891L24.501 9.80293C24.9632 10.4178 25.1975 10.7295 25.2999 11.0568C25.4133 11.414 25.4133 11.7908 25.2999 12.148C25.1968 12.4778 24.9648 12.7918 24.4956 13.4159L19.2133 20.5256L19.1997 20.5438C18.7344 21.1637 18.4987 21.4779 18.1719 21.7149C17.8162 21.974 17.3883 22.1623 16.9191 22.2685C16.4912 22.3587 16.0118 22.3587 15.0529 22.3587ZM25.338 22.3587H31.1739C32.0348 22.3587 32.468 22.3587 32.7259 22.2294C33.0042 22.0919 33.1794 21.8602 33.1951 21.6091C33.2099 21.3851 33.0031 21.1134 32.5979 20.581C32.5839 20.5629 32.57 20.5444 32.5557 20.5257L29.6325 16.7181L29.5992 16.6752C29.1884 16.1463 28.9811 15.8792 28.7148 15.776C28.4211 15.6621 28.0754 15.6621 27.7817 15.776C27.5136 15.882 27.2971 16.1607 26.8692 16.722L23.9564 20.5296L23.9464 20.5427C23.52 21.1031 23.3069 21.3832 23.3222 21.613C23.3429 21.8642 23.513 22.0957 23.7914 22.2332C24.044 22.3587 24.4771 22.3587 25.338 22.3587Z",
    fill: "#100F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.eae56024a7780702426403472b39a1d4.svg";
export { ForwardRef as ReactComponent };